module.exports = __webpack_public_path__ + "static/media/taaltaal.f8b445cf.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/taaltaal.webp
// module id = 413
// module chunks = 0